import * as vp from 'vopay';

import { FunctionComponent } from 'react';

import AccountOverviewContainer from './widgets/Accounts/AccountOverviewContainer';
import TransactionsOverviewContainer from './widgets/Transactions/TransactionsOverviewContainer';
import PerformanceOverviewContainer from './widgets/Performance/PerformanceOverviewContainer';
import ActivityOverviewContainer from './widgets/Activity/ActivityOverviewContainer';
import { useTranslation } from 'react-i18next';

const { Box, Title } = vp;

type FC = FunctionComponent;

const Homepage: FC = () => {
  const { t } = useTranslation('translations', { keyPrefix: 'HomePage' });
  return (
    <>
      <Title title={t('pageTitle')} bold />

      <Box gap="ml" mb="lg" mt="md">
        <AccountOverviewContainer />
        <TransactionsOverviewContainer />
        <PerformanceOverviewContainer />
      </Box>
      <ActivityOverviewContainer />
    </>
  );
};

export default Homepage;
